<template>
  <div>
    <div class="container">
      <Form ref="productCustom" :model="productCustom" :label-width="80">
        <FormItem label="企业代码" v-if="getControl() == 1">
          <Input v-model="productCustom.ClientCode" @click="SelectClientSwitch = !SelectClientSwitch"
            placeholder="请输入企业代码"></Input>
        </FormItem>

        <FormItem label="字段名称">
          <Input v-model="productCustom.name" placeholder="请输入字段名称"></Input>
        </FormItem>

        <FormItem label="备注说明">
          <Input v-model="productCustom.remark" type="textarea" :autosize="{ minRows: 2, maxRows: 5 }"
            placeholder="请输入说明..."></Input>
        </FormItem>
      </Form>
    </div>

    <div class="btn">
      <Button @click="echo()" type="success" style="width: 100px; height: 40px">保&nbsp;存</Button>
    </div>

    <!-- 选择企业 -->
    <transition name="fade">
      <SelectClient v-if="SelectClientSwitch" @Value="SelectClientVal" @close="SelectClientClose"></SelectClient>
    </transition>
  </div>
</template>

<script>
import FiledUpload from "@/views/FiledUpload";
import { NewProductCustom } from "@/api/index";
import SelectClient from "@/views/selectClient";
import { mapState } from "vuex";
export default {
  data() {
    return {
      number: 10,
      title1: "",
      productCustom: {
        name: "",
        ClientCode: "",
        remark: "",
      },
      arr: [
        {
          title: "产品名称",
          type: "text",
          message: "",
        },
        {
          title: "产品价格",
          type: "text",
          message: "",
        },
        {
          title: "产品规格",
          type: "text",
          message: "",
        },
        {
          title: "生产地址",
          type: "text",
          message: "",
        },
        {
          title: "生产商",
          type: "text",
          message: "",
        },
      ],
      SelectClientSwitch: false,
    };
  },
  components: {
    SelectClient,
    FiledUpload,
  },
  watch: {},
  computed: mapState({
    control: (state) => state.control,
  }),
  created() {
    //   console.log('1-'+this.control);
  },
  methods: {
    getControl() {
      return this.control;
    },
    SelectClientClose() {
      this.SelectClientSwitch = false;
    },
    SelectClientVal(value) {
      this.productCustom.ClientCode = value;
      this.SelectClientSwitch = false;
    },
    propsTitleVal(key) {
      return this.arr[key].title;
    },
    propsMessageVal(key) {
      return this.arr[key].message;
    },
    add() {
      this.arr.push({ title: "", type: "text", message: "" });
    },

    // 完成按钮
    echo() {
      if (this.productCustom.name === "") {
        this.$message({
          type: "error",
          message: "字段名称不要留空哦！",
        });
      } else {
        NewProductCustom({
          clientcode: this.productCustom.ClientCode,
          name: this.productCustom.name,
          remark: this.productCustom.remark,
        }).then((res) => {
          if (res == 1) {
            this.$emit("close", true);
          }
        });
      }
    },

    title(event, key) {
      this.arr[key].title = event;
    },
    message(event, key) {
      this.arr[key].message = event;
    },
    jian(key) {
      // console.log(key);
      this.arr[key] = {};
      this.arr.splice(key, 1);
    },
  },
};
</script>

<style scoped>
.container {
  max-height: calc(100% - 100px);
}

.containers {
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 10px;
}

.line {
  line-height: 32px;
}

.jian {
  margin-left: 10px;
  height: 32px;
  width: 32px;
  cursor: pointer;
}

.jian_img {
  width: 100%;
}
</style>
